import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavItem, NavEntryPoint } from '@retailer-platform/dashboard/routing'
import { emergingBrandsPortalRouter } from './routing/emergingBrandsPortalRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import ES_ES from './translations/es-ES.json'
import FR_FR from './translations/fr-FR.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { emergingBrandsPortalAccessControl } from './access-control/emergingBrandsPortalAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'emerging-brands-portal',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'emerging-brands-portal-dashboard-tool',
  },
  routes,
  translations: { EN_US, ES_ES, FR_FR },
  routers: {
    scoped: [emergingBrandsPortalRouter],
  },
  navigationEntries: [
    {
      attachTo: NavItem.BrandExplorer,
      attachToV2: NavEntryPoint.Catalog,
      subNavItems: [
        {
          type: 'item',
          llmDescription:
            'Discover and manage new brands entering the catalog for shelf placement and promotion',
          labelId: 'emergingBrandsPortalDomain.title',
          route: 'emerging-brands-portal-search',
          accessControl: emergingBrandsPortalAccessControl,
          isNew: true,
          positionNavV2: 4,
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
